export default {
  postDetail_reply_time:'按回复时间',
  postDetail_comment_time:'按评论时间',
  postDetail_undercarriage_tip1:'下架后，可在“我的帖子-我管理的评论和回复”中找到该内容，并恢复上架，确定要下架吗？',
  postDetail_cancel_reply:'取消优质回帖',
  postDetail_set_reply:'设为优质回帖',
  postDetail_enter_commments:'请输入评论',
  postDetail_limit_comment:'评论字数限制1000字',
  postDetail_related_resources:'相关资源',
  postDetail_had_click:'您已@该人员',
  postDetail_undercarriage_tip2:'下架后，可在“我的帖子-我管理的帖子”中找到该内容，并恢复上架，确定要下架吗？'
}
